import * as React from 'react';
import { cn } from '@/lib/utils';
import * as Icons from 'lucide-react';

const statusConfig = {
  warn: {
    icon: Icons.AlertTriangle,
    className: 'text-warning bg-warning/10 border-warning/20',
  },
  danger: {
    icon: Icons.AlertCircle,
    className: 'text-destructive bg-destructive/10 border-destructive/20',
  },
  ok: {
    icon: Icons.CheckCircle2,
    className: 'text-success bg-success/10 border-success/20',
  },
  info: {
    icon: Icons.Info,
    className: 'text-info bg-info/10 border-info/20',
  },
};

export function ExceptionList({ items = [], emptyMessage = 'No exceptions — pipeline looks clear.' }) {
  if (!items || items.length === 0) {
    return (
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Icons.CheckCircle2 className="h-4 w-4 text-success" />
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {items.map((item, idx) => {
        const config = statusConfig[item.status] || statusConfig.info;
        const Icon = config.icon;

        return (
          <div
            key={idx}
            className={cn(
              'flex items-start gap-3 p-3 rounded-lg border',
              config.className
            )}
          >
            <Icon className="h-4 w-4 mt-0.5 flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium">{item.title}</p>
              {item.description && (
                <p className="text-xs opacity-80 mt-1">{item.description}</p>
              )}
            </div>
            {item.action && (
              <button
                type="button"
                className="text-xs font-medium hover:underline flex-shrink-0"
                onClick={() => item.onAction?.()}
              >
                {item.action}
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}